export default {
  color: {
    white: '#fff',
    black: '#111',
    charcoal: '#4a556b',
    steel: '#9ba1ad',
    red: '#ff004d',
    blue: '#005aff',
    linkwater: '#c7cad1',
    whitesmoke: '#f5f5f5',
    solitude: '#e9ecf1',
    manatee: '#8f94a0',
    columbiablue: '#afccff',
    dodgerblue: '#3e82ff',
    gainsboro: '#e0e0e0',
    mischka: '#9ea4af',
    charade: '#3c4042',
    harlequin: '#42c900',
    veryLightGrey: '#cacaca',
    ghost: '#c7c9cc',
    columbiaBlue: '#afcbff',
    radicalRed: '#ff4056',
  },
  fontSize: {
    default: '16px',
  },
  fontFamily: {
    default: `'Helvetica Neue', Helvetica, Arial, sans-serif`,
  },
};
